import React, { useEffect, useState } from 'react'
import { sendWebViewMsg } from 'utils/bridge'
import styled from 'styled-components'
import { UAParser } from 'ua-parser-js'
import qs from 'qs'
import { useHistory } from 'react-router-dom'
import { lt } from 'semver'
import server from 'server/serverController2'
export default function NativeVersionChecker(props) {
  const [showUpdateModal, setShowUpdateModal] = useState(false)
  const history = useHistory()
  const appleStoreLink =
    'https://apps.apple.com/kr/app/%EB%AA%A8%ED%8B%B0%EB%84%88%EC%8A%A4/id1556370860'
  const googleStoreLink = 'https://play.google.com/store/apps/details?id=com.motiners.bundle'

  let parserObj = new UAParser()
  const OSInfo = parserObj.getOS()
  const appStoreLink = OSInfo['name'] === 'Android' ? googleStoreLink : appleStoreLink

  const checkNativeVersion = async () => {
    try {
      if (window?.ReactNativeWebView?.postMessage) {
        let response = await sendWebViewMsg({
          action: 'REQ_GET_VERSION',
          timeout: true,
          timeoutSec: 8000,
        }).catch((err) => {
          console.log('err from msg')
          console.log(err)
        })
        console.log(response)
        if (response.success !== 1) {
          setShowUpdateModal(false)
          return
        }

        let deviceVersion =
          response.success === 1 && response?.data?.version ? response.data.version : null

        let form = {}
        form['type'] = OSInfo['name'] === 'Android' ? 'android' : 'ios'
        form['type_version'] = 'min'
        let queryString = qs.stringify(form)
        response = await server.getRequestData(`version?${queryString}`)

        if (response.success !== 1) {
          setShowUpdateModal(false)
          return
        }

        if (
          response.success === 1 &&
          response?.data?.version &&
          ![null, undefined, '', 'null'].includes(deviceVersion)
        ) {
          if (response?.data?.version) {
            const minDeviceVersionInfo = response.data.version[0]
            const minVersion = minDeviceVersionInfo['version']

            if (lt(deviceVersion, minVersion)) {
              setShowUpdateModal(true)
            } else {
              setShowUpdateModal(false)
            }
            return
          }
        }
      }

      setShowUpdateModal(false)
      return
    } catch (err) {
      const errData = err?.error?.res_data
      if (errData?.detail_code === 'BRIDGE_MESSAGE_TIMEOUT') {
        //setShowUpdateModal(true);
      } else {
        setShowUpdateModal(false)
      }
    }
  }
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    let visibilityChange = null
    if (typeof document.hidden !== 'undefined') {
      // Opera 12.10 and Firefox 18 and later support
      visibilityChange = 'visibilitychange'
    } else if (typeof document.msHidden !== 'undefined') {
      visibilityChange = 'msvisibilitychange'
    } else if (typeof document.webkitHidden !== 'undefined') {
      visibilityChange = 'webkitvisibilitychange'
    } else {
      visibilityChange = 'visibilitychange'
    }
    checkNativeVersion()
    history.listen((location, action) => {
      checkNativeVersion()
    })
    const onFocusHandler = () => {
      checkNativeVersion()
    }
    window.addEventListener(visibilityChange, onFocusHandler)

    return function cleanup() {
      window.removeEventListener(visibilityChange, onFocusHandler)
    }
  }, [])

  return (
    <>
      {showUpdateModal ? (
        <UpdateModalSection>
          <ModalBackground></ModalBackground>
          <ModalSection>
            <ModalBody>
              <ModalTitle>{`새 버전이 있습니다!`}</ModalTitle>
              <ModalDescription>
                {`모티너스를 더 편리하게 개선했어요.`}
                <br />
                {`서비스를 계속 이용하시려면`}
                <br />
                {`업데이트를 해 주세요:)`}
              </ModalDescription>
            </ModalBody>
            <ModalFooter>
              <UpdateBtn target={'_blank'} href={appStoreLink}>
                업데이트
              </UpdateBtn>
            </ModalFooter>
          </ModalSection>
        </UpdateModalSection>
      ) : null}
    </>
  )
}

export const UpdateModalSection = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background: white;
  z-index: 2000;
`

export const ModalBackground = styled.div`
  opacity: 0.4;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #000000;
`

export const ModalSection = styled.div`
  position: absolute;
  background: #ffffff;
  border-radius: 10px;
  z-index: 20000;
  left: 0;
  right: 0;
  top: 0;
  bottom: 150px;
  height: fit-content;
  width: fit-content;
  margin: auto;
`

export const ModalBody = styled.div`
  padding: calc(100vw * (17 / 375)) calc(100vw * (38 / 375)) calc(100vw * (16 / 375))
    calc(100vw * (38 / 375));
  border-bottom: 1px solid #eaeaea;
`
export const ModalTitle = styled.div`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: calc(100vw * (18 / 375));
  color: #000000;
  margin-bottom: calc(100vw * (10 / 375));
`
export const ModalDescription = styled.div`
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-size: calc(100vw * (14 / 375));
  text-align: center;
  color: #000000;
`
export const ModalFooter = styled.div``
export const UpdateBtn = styled.a`
  display: block;
  text-align: center;
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (16 / 375));
  color: #0082ff;
  padding: calc(100vw * (11 / 375)) calc(100vw * (0 / 375)) calc(100vw * (13 / 375));
`
